<template>
    <div v-if="currentUnit" class="sidebar--detail-extend_wrapper">
        <div class="sidebar--detail_header">
            <div class="header--main_wrapper">
<!--                Bouton desktop-->
                <a class="back--to_btn cursor-pointer  back-to_desk" @click.prevent="handleCloseFilters">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z"/></svg>
                    <span class="back--to">{{ t('Retour à la maquette', 'Retour à la maquette') }}</span>
                </a>
<!--                Bouton mobile-->
                <a class="back--to_btn cursor-pointer back-to_resp" @click.prevent="handleCloseFilters">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z"/></svg>
                    <span class="back--to">{{ t('Retour à la maquette', 'Retour à la maquette') }}</span>
                </a>
                <div class="header--house">
                    <div class="title--house">
                        <h2>
                            {{ currentUnit.translatable.fullname[locale] ? currentUnit.translatable.fullname[locale] : currentUnit.name }}
                        </h2>
                        <div class="availability">{{ currentUnit.status && currentUnit.status.translatable.name[locale] ? currentUnit.status.translatable.name[locale] : '' }}</div>
                        <div v-if="currentUnit.units_count > 0" class="availability">
                            {{ t('Duplex', 'Duplex') }}
                        </div>
                    </div>
                </div>
                <div class="close--resp">
                    <button type="button" @click.prevent="handleCloseFilters" class="close--btn_second">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                    </button>
                </div>
            </div>
            <div class="content--general_wrapper">
                <div class="img--content">
                    <vue-easy-lightbox
                        :visible="visible"
                        :imgs="files"
                        class="modal--plan"
                        :index="index"
                        @hide="handleCloseLightBox"
                    ></vue-easy-lightbox>

                    <template v-if="currentImageType === '2D'">
                        <div class="m-2 w-full h-full hover--img" v-if="hasBlueprints2D">
                            <img :src="blueprints2D[0].url" alt="" class="cursor-pointer" @click="handleOpenLightBox(getBlueprints2DImage)">
                        </div>
                        <div class="m-2 w-full h-full hover--img" v-else>
                            <img src="../../../../img/unavailable-blueprint.png" alt="" class="cursor-pointer" @click="handleOpenLightBox(1)">
                        </div>
                    </template>

                    <template v-if="currentImageType === '3D'">
                        <div class="m-2 w-full h-full hover--img" v-if="currentUnit.blueprint3D">
                            <img :src="currentUnit.blueprint3D" alt="" class="cursor-pointer" @click="handleOpenLightBox(0)">
                        </div>
                        <div class="m-2 w-full h-full hover--img" v-else>
                            <img src="../../../../img/unavailable-blueprint.png" alt="" class="cursor-pointer" @click="handleOpenLightBox(0)">
                        </div>
                    </template>

                    <template v-if="currentImageType === '360'">
                        <div class="m-2 w-full h-full hover--img" v-if="has360View">
                            <Image360Viewer :images="get360Images" :sensitivity="5"/>
                        </div>
                        <div class="m-2 w-full h-full hover--img" v-else>
                            <img src="../../../../img/unavailable-blueprint.png" alt="">
                        </div>
                    </template>

                    <div class="flex flex-row mb-2 w-4/5 button--main_action">
                        <button v-if="hasBlueprints2D" type="button" class="btn--main btn--switch m-2" :class="currentImageType === '2D' ? 'active' : ''" @click.prevent="handleChangeCurrentImageType('2D')"> 2D</button>
                        <button v-if="currentUnit.blueprint3D" type="button" class="btn--main btn--switch m-2" :class="currentImageType === '3D' ? 'active' : ''" @click.prevent="handleChangeCurrentImageType('3D')"> 3D</button>
                        <button type="button" class="btn--main btn--switch m-2" :class="currentImage === '360' ? 'active' : ''" @click.prevent="handleChangeCurrentImageType('360')" v-if="has360View"> 360°</button>
                    </div>
                </div>
                <div class="house--content">
                    <div class="house--detail">
                        <div class="header--detail">
                            <h2>{{ t('Informations', 'Informations') }}</h2>
                            <span v-if="currentUnit.name || currentUnit.fullname">{{ currentUnit.fullname ? currentUnit.fullname : currentUnit.name }}</span>
                            <div class="whitespace-pre-line" v-html="currentUnit.description">
                            </div>
                            <span v-if="currentUnit.project && currentUnit.project.show_price && currentUnit.price > 0 && currentUnit.status && currentUnit.status.id === 1" class="price">
                                {{ new Intl.NumberFormat('fr-BE', {
                                    style: 'currency',
                                    currency: 'EUR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                }).format(currentUnit.price)}}
                                <small v-if="withPriceDetail">{{ currentUnit.price_detail }}</small>
                            </span>
                        </div>
                        <div class="detail--house_content">
                            <span v-if="currentUnit.project && currentUnit.project.show_category">
                                {{ currentUnit.category && currentUnit.category.translatable.name[locale] ? currentUnit.category.translatable.name[locale] : t('Pas de catégorie', 'Pas de catégorie') }}
                            </span>
                            <span v-if="currentUnit.bedrooms > 0 && project" class="detail--house_txt nbr--bedroom">
                                 <template v-if="PROJECT_TOPOLOGY.labels[project.topology] === 'T'">
                                    {{ currentUnit.bedrooms === 1 ? 'ST' : 'T' + currentUnit.bedrooms }}
                                </template>
                                <template v-else>
                                    {{ currentUnit.bedrooms + ' ' + t('chambre(s)', 'chambre(s)') }}
                                </template>
                            </span>
                            <span v-if="currentUnit.surface > 0 && currentUnit.status && currentUnit.status.id !== 2" class="detail--house_txt surface">
                               {{ t('Surface :', 'Surface :') }} {{ currentUnit.surface }} m<sup>2</sup>
                            </span>
                            <span v-if="currentUnit.has_balcony" class="detail--house_txt bonus">
                               {{ currentUnit.has_balcony ? t("Avec balcon", "Avec balcon") : "" }}
                            </span>
                            <span v-if="currentUnit.has_terrace" class="detail--house_txt bonus">
                               {{ currentUnit.has_terrace ? t("Avec terrasse", "Avec terrasse") : "" }}
                            </span>
                            <span v-if="currentUnit.has_garden" class="detail--house_txt bonus">
                               {{ currentUnit.has_garden ? t("Avec jardin", "Avec jardin") : "" }}
                            </span>
                            <span v-if="currentUnit.has_loggia" class="detail--house_txt bonus">
                               {{ currentUnit.has_loggia ? t("Avec loggia", "Avec loggia") : "" }}
                            </span>
                        </div>
                    </div>
                    <div class="btn--actions">
                        <button type="button" class="btn--main btn--contact mb-2" @click.prevent="handleOpenMailToModal" v-if="withSendByEmailButton">{{ t('Envoyer par Email', 'Envoyer par Email') }}</button>
                        <button type="button" class="btn--main btn--contact mb-2 hover:opacity-70" @click.prevent="handleOpenContactModal" v-if="withContactUsButton">{{ t('Contactez-nous', 'Contactez-nous') }}</button>
                        <button type="button" class="btn--main btn--contact mb-2 hover:opacity-70" @click.prevent="handleDownloadBlueprints" v-if="withBlueprintDownloadButton">{{ t('Télécharger le plan', 'Télécharger le plan') }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isMailModalOpen" class="send--by_mail fixed top-0 left-0 w-full h-full flex items-center justify-center" @click.self="handleCloseMailToModal">
            <form class="form--content_wrapper w-1/2 bg-white p-5 shadow-md" :class="withFilter ? 'with-filter' : 'without-filter'" action="#" method="POST" @submit.prevent="handleSendMailTo">
                <div class="form--wrapper">
                    <div class="flex flex-row justify-between mb-16">
                    <h2 class="text-4xl font-medium flex items-center">
                        {{ t('Envoyer par mail', 'Envoyer par mail') }}
                        <Loader class="ml-2" v-if="isMailToPending"/>
                    </h2>
                    <button class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-custom-green" title="Close this window" @click.prevent="handleCloseMailToModal">
                        <svg class="h-6 w-6 fill-gray-500 hover:fill-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/></svg>
                    </button>
                </div>

                <div class="flex flex-col mb-4">
                    <label for="first_name" class="text-gray-300">{{ t('Prénom', 'Prénom') }}</label>
                    <input id="first_name" name="first_name" placeholder="" type="text" v-model="mail.first_name" class="border-b border-b-2 border-b-gray-300 focus:outline-none focus:shadow-outline">
                    <div v-if="errors.first_name" class="text-red-500 mt-1">
                        <span v-for="message in errors.first_name">{{ message }}</span>
                    </div>
                </div>

                <div class="flex flex-col mb-4">
                    <label for="last_name" class="text-gray-300">{{ t('Nom', 'Nom') }}</label>
                    <input id="last_name" name="last_name" placeholder="" type="text" v-model="mail.last_name" class="border-b border-b-2 border-b-gray-300 focus:outline-none focus:shadow-outline">
                    <div v-if="errors.last_name" class="text-red-500 mt-1">
                        <span v-for="message in errors.last_name">{{ message }}</span>
                    </div>
                </div>

                <div class="flex flex-col mb-4">
                    <label for="from" class="text-gray-300">{{ t('Email', 'Email') }}</label>
                    <input id="email" name="email" placeholder="" type="text" v-model="mail.email" class="border-b border-b-2 border-b-gray-300 focus:outline-none focus:shadow-outline">
                    <div v-if="errors.email" class="text-red-500 mt-1">
                        <span v-for="message in errors.email">{{ message }}</span>
                    </div>
                </div>

                <div class="flex mt-6 mb-4">
                    <label for="rgpd_acceptance" class="flex items-center">
                        <input id="rgpd_acceptance" type="checkbox" name="rgpd_acceptance" class="border border-gray-200" value="true" v-model="mail.rgpd_acceptance">
                        <template v-if="project.translatable.gdpr && project.translatable.gdpr[locale]">
                            <div class="ml-2" v-html="project.translatable.gdpr[locale]"></div>
                        </template>
                        <template v-else>
                            <span class="ml-2">
                                {{ t('Vous acceptez que nous utilisions vos données conformément à nos', 'Vous acceptez que nous utilisions vos données conformément à nos') }}
                                <template v-if="project.cgu">
                                    <a :href="project.cgu" target="_blank" class="inline transition-opacity opacity-50 hover:opacity-80">{{ t('conditions générales', 'conditions générales') }}</a>
                                </template>
                                <template v-else>
                                    {{ t('conditions générales', 'conditions générales') }}
                                </template>
                            </span>
                        </template>
                    </label>
                    <div v-if="errors.rgpd_acceptance" class="text-red-500 mt-1">
                        <span v-for="message in errors.rgpd_acceptance">{{ message }}</span>
                    </div>
                </div>

                <div class="button--main">
                    <button type="submit" class="btn--main btn--contact mb-2" role="button" aria-label="Bouton envoyer le message" id="button--contact">
                        {{ t('Envoyer', 'Envoyer') }}
                    </button>
                </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import Axios from "axios";
    import PROJECT_TOPOLOGY from "../../enums/project-topology";
    import VueEasyLightbox from "vue-easy-lightbox"
    import Loader from "../partials/loader.vue";
    import Image360Viewer from "../Image360Viewer.vue";
    import t from "../../composables/Translator";

    export default {
        emits: ['closeUnit', 'closeFilters'],
        props: {
            currentUnit: Object,
            project: Object,
            building: Object,
            floor: Object,
            withFilter: Boolean
        },
        data() {
            return {
                isMailModalOpen: false,
                isMailToPending: false,
                showRecaptcha: true,
                mail: {
                    rgpd_acceptance: false,
                    recaptcha_token: null,
                    email: null,
                    first_name: null,
                    last_name: null
                },
                errors: {},
                PROJECT_TOPOLOGY: PROJECT_TOPOLOGY,
                visible: false,
                index: 0,
                currentImageType: this.currentUnit?.blueprint3D ? '3D' : '2D',
                has360View: false,
                currentBlueprint2DIndex: 0
            }
        },
        computed: {
            siteKey() {
                return '6Ld3a-AeAAAAAJzUVDB3Qf8XygXoPAcVT4tDUDOd'
            },
            withSendByEmailButton() {
                if(this.project && this.project.settings.data.find( setting => setting.name === 'with-send-by-email-button' )) {
                    return !!Number(this.project.settings.data.find( setting => setting.name === 'with-send-by-email-button' ).value)
                }

                return true
            },
            withContactUsButton() {
                if(this.project && this.project.settings.data.find( setting => setting.name === 'with-contact-us-button' )) {
                    return !!Number(this.project.settings.data.find( setting => setting.name === 'with-contact-us-button' ).value)
                }

                return true
            },
            withBlueprintDownloadButton() {
                if(this.project && this.project.settings.data.find( setting => setting.name === 'with-download-blueprint-button' )) {
                    return !!Number(this.project.settings.data.find( setting => setting.name === 'with-download-blueprint-button' ).value)
                }

                return true
            },
            withPriceDetail() {
                if(this.project && this.project.settings.data.find( setting => setting.name === 'with-price-detail' )) {
                    return !!Number(this.project.settings.data.find( setting => setting.name === 'with-price-detail' ).value)
                }

                return true
            },
            get360Images() {
                if (this.currentUnit) {
                    // Construire le chemin de base
                    const basePath = `${process.env.MIX_APP_URL}/storage/v360/${this.project?.name?.toLowerCase()}/${this.building?.name?.toLowerCase()}/${this.currentUnit.name?.toLowerCase()}`;

                    // Charger le fichier de configuration
                    return Axios.get(`${basePath}/config.json`)
                        .then(response => {
                            const { totalImages } = response.data;
                            const images = [];
                            for (let i = 0; i < totalImages; i++) {
                                const imageNumber = i.toString().padStart(2, '0');
                                images.push(`${basePath}/${imageNumber}.jpg?v=2`);
                            }
                            return images;
                        })
                        .catch(error => {
                            console.error('Erreur lors du chargement de la configuration 360°:', error);
                            return [];
                        });
                }
                return Promise.resolve([]);
            },
            locale() {
                return this.$store.getters['config/locale'];
            },
            blueprints2D() {
                if (this.currentUnit && this.currentUnit.blueprints2D && this.currentUnit.blueprints2D.data) {
                    return this.currentUnit.blueprints2D.data;
                }

                return [];
            },
            hasBlueprints2D() {
                return this.blueprints2D.length > 0;
            },
            getCurrentBlueprints2D() {
                if (this.blueprints2D.length > 0) {
                    return this.blueprints2D[this.currentBlueprint2DIndex];
                }
                return null;
            },
            files() {
                if(this.currentImageType === '2D') {
                    return this.blueprints2D.map(blueprint2D => blueprint2D.url);
                }
                if(this.currentImageType === '3D') {
                    return [this.currentUnit.blueprint3D];
                }
                return [];
            }
        },
        watch: {
            currentUnit() {
                this.currentImageType = this.currentUnit?.blueprint3D ? '3D' : '2D';
                this.currentBlueprint2DIndex = 0; // Reset l'index quand on change d'unité
                this.check360ViewAvailability();
            }
        },

        methods: {
            handleCloseUnit() {
                this.$emit('closeUnit');
            },
            handleCloseFilters() {
                this.$emit('closeFilters');
            },
            handleOpenMailToModal() {
                this.isMailModalOpen = true;
            },
            handleCloseMailToModal() {
                this.isMailModalOpen = false;
            },
            handleOpenContactModal() {
                this.$store.dispatch('modals/open', {
                    name: 'contact',
                    data: {
                        project: this.project
                    }
                })
            },
            handleCloseLightBox() {
                this.visible = false
            },
            handleOpenLightBox() {
                this.index = 0;
                this.visible = true;
            },
            handleChangeCurrentImageType(image_type) {
                this.currentImageType = image_type
            },
            async handleSendMailTo() {
                await this.$recaptchaLoaded()
                const token = await this.$recaptcha('login')
                this.isMailToPending = true;

                let data = {
                    ...this.mail,
                    url: this.$router.resolve({ name: 'orbital-show',
                        params: {
                            project: this.project.name.toLowerCase(),
                            building: this.building.name.toLowerCase(),
                            floor: this.floor.name.toLowerCase(),
                            unit: this.currentUnit.name
                        }}).href,
                    recaptcha_token: token,
                    unit_id: this.currentUnit.id
                }

                Axios.post(`${process.env.MIX_APP_URL}/unit/mail-to`, data)
                    .then( (response) => {
                        this.isMailModalOpen = false;
                        this.mail = {
                            rgpd_acceptance: false,
                            recaptcha_token: null,
                            from: null,
                        };

                        this.$store.dispatch('toasts/add', {type: 'success', message: response.data.message}, {root: true})
                    })
                    .catch(error => {
                        console.warn(error);
                        if (error.data && error.status === 422) {
                            this.errors = error.data.errors
                        }
                    }).finally( () => {
                        this.isMailToPending = false;
                    })
            },
            handleDownloadBlueprints() {
                if(this.currentUnit) {
                    window.location.href = "/download/"+this.currentUnit.id+"/blueprints";
                }
            },
            async check360ViewAvailability() {
                try {
                    const response = await Axios.get(`${process.env.MIX_APP_URL}/storage/v360/${this.project?.name?.toLowerCase()}/${this.building?.name?.toLowerCase()}/${this.currentUnit.name?.toLowerCase()}/config.json`);

                    this.has360View = response.data.totalImages ? true : false;
                } catch (error) {
                    this.has360View = false;
                }
            },
            t(...args) {
                return t(...args);
            },
            previousBlueprints2D() {
                if (this.currentBlueprint2DIndex > 0) {
                    this.currentBlueprint2DIndex--;
                }
            },
            nextBlueprints2D() {
                if (this.currentBlueprint2DIndex < this.blueprint2DImages.length - 1) {
                    this.currentBlueprint2DIndex++;
                }
            },

        },
        mounted() {
            this.check360ViewAvailability();
        },
        components: {
            VueEasyLightbox,
            Loader,
            Image360Viewer
        }
    }
</script>
